import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { CommonService } from 'src/app/_services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'alert-popup',
  templateUrl: './alertPopup.component.html',
  styleUrls: ['./alertPopup.component.scss']
})
export class alertPopupComponent implements OnInit {
  iconPath = appConfig.iconPath;
  imgPath = appConfig.imagePath;
  @Input() alterMessage : string;
  @Input() showCancel : string;
  @Input() successButtonText : boolean;
  @Output() onAlertSuccess = new EventEmitter()
  @Output() onCancel = new EventEmitter()

  constructor(
    private commonService: CommonService,
    private modalService: NgbModal,
    private router: Router
    ) { }

  ngOnInit() { }
  
  onSuccess(){
    this.onAlertSuccess.emit();
    this.closeModal()
  }
  closeModal(){
    this.onCancel.emit();
    this.modalService.dismissAll()
  }

}
